import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom"; // useLocation 추가
import { FirmWare } from "./item/firmware";
import { Manual } from "./item/manuel";
import { SpeedCam } from "./item/speedCam";
import { useGetDocLangMutation, useGetProductDocMutation } from "../../../../../store/user/userProductApiSlice";
import { useGetUserProductDocsMutation } from "../../../../../store/user/userApiSlice";

interface ManualBoxProps {
    battery?: boolean;  // 선택적 prop
}

export const ManualBox = ({battery}: ManualBoxProps) => {
    const {productId} = useParams() // 제품 아이디 (이 부분은 사용하지 않음)
    const {id} = useParams() // 유저 아이디
    const location = useLocation(); // useLocation 훅을 사용하여 location 객체를 가져옵니다.
    const [productIds, setProductId] = useState<string | null>(null); // productId 상태 추가

    const [docType , setDocType] = useState<any>({tab : 1})
    const [getProductDocApi] = useGetProductDocMutation()
    const [getUserProductDocsApi] = useGetUserProductDocsMutation()
    const [getDocLangApi] = useGetDocLangMutation()
    const [data, setData] = useState<any>([])
    const [lang, setLang] = useState<any>([])
    const [param, setParam] = useState<any>({userId : id, productId : productIds, docType : battery ? 'M' : 'F', langType : 1})

    // URL에서 productId를 추출하는 useEffect
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const idFromUrl = queryParams.get('productId');
        if (idFromUrl) {
            setProductId(idFromUrl);
            setParam((prev:any)=>({...prev, productId : idFromUrl})); // productId를 param에도 설정
        } else {
            setProductId(productId || null);
            setParam((prev:any)=>({...prev, productId : productId}));
        }
    }, [location.search]); // location.search가 변경될 때마다 실행

    // 리스트 가져오기
    const getList = async() => {
        if(param.productId){ // 제품 상세정보에서의 제품 문서
            const result : any = await getProductDocApi(param)
            if(result.data.Result === 'true'){setData(result.data.List)}
        }
        if(id){ // 유저 MyDashCam 에서의 제품 문서
            const result : any = await getUserProductDocsApi(param)
            if(result.data.Result === 'true'){setData(result.data.List)}
        }
    }
    // 언어 가져오기
    const getLang = async() => {
        const result : any = await getDocLangApi({docType : param?.docType, productId : param.productId})
        if(result.data.Result === 'true'){setLang(result.data.List)}
    }
    // 탭 변경
    const handleChangeTab = (tab:number, type:string) => {
        setDocType({tab : tab})
        setParam((prev:any)=>({...prev, docType : type}))
    }
    // 언어 변경
    const handleChange = (e:any) => {
        setParam((prev:any)=>({...prev, langType : e.target.value}))
    }
    useEffect(()=>{
        getLang()
    }, [param.docType, param.productId]) // productId가 변경될 때도 getLang 호출
    useEffect(()=>{getList()}, [docType, param.langType, param.productId]) // productId가 변경될 때도 getList 호출
    return(
      <>
          <div className="manualsAndFirmware active">
              <section>
                  <div className="slide_tabBtnWrap">
                      <div className={`slide_tabBtnBox number${productIds ? battery ? 1 : 3 : battery ? 1 : 4} active_${docType.tab}`}>
                          {!battery && (
                            <button onClick={() => handleChangeTab(1, 'F')}>
                                <span>Firmware</span>
                            </button>
                          )}

                          <button onClick={() => handleChangeTab( battery ? 1 : 2, 'M')}>
                              <span>User Manual</span>
                          </button>
                          {!battery && (
                            <button onClick={() => handleChangeTab(3, 'S')}>
                                <span>Speed Cam Data</span>
                            </button>
                          )}
                          {productIds ? '' :
                            <button onClick={() => handleChangeTab(4, '')}>
                                <span>User Warrenty</span>
                            </button>}
                      </div>

                      <div className="selectBox">
                          <select onChange={handleChange}>
                              <option value={''} selected>-</option>
                              {lang?.map((lang:any)=>(
                                <option value={lang?.langIdx}>{lang?.langNameEn}</option>
                              ))}
                          </select>
                      </div>
                  </div>

                  <div className="tabContentBox">
                      {docType.tab === 1 ? battery ? <Manual data={data}/> : <FirmWare data={data} lang={lang}/> : ''}
                      {docType.tab === 2 ? <Manual data={data}/> : ''}
                      {docType.tab === 3 ? <SpeedCam data={data}/> : ''}
                  </div>
              </section>
          </div>
      </>
    )
}
